// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-B":"B_dpu-detail-B__8SM2I"};